export { PermissionDenied } from './PermissionDenied/PermissionDenied';
export { Unexpected } from './Error/Unexpected';
export { Balloon } from './Balloon/Balloon';

// News illustrations
export { NotFound404 } from './NotFound404/NotFound404';
